
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"tags"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.75.883h5.732c.332 0 .65.131.884.366l8.384 8.384M7.607 3.383H2.5a1.25 1.25 0 00-1.25 1.25v5.106a1.25 1.25 0 00.366.885l8.125 8.125a1.248 1.248 0 001.768 0l5.107-5.108a1.25 1.25 0 000-1.767L8.49 3.749a1.25 1.25 0 00-.883-.366z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5 6.82a.312.312 0 100 .625.312.312 0 000-.625z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    